// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
// eslint-disable-next-line
import Favorite from "@material-ui/icons/Favorite"
// eslint-disable-next-line
import FavoriteBorder from "@material-ui/icons/FavoriteBorder"
// eslint-disable-next-line
import UncheckedCircle from "@material-ui/icons/RadioButtonUnchecked"
// eslint-disable-next-line
import CheckedCircle from "@material-ui/icons/CheckCircleOutline"
// eslint-disable-next-line
import Checkbox from "@material-ui/core/Checkbox"
import Fab from "@material-ui/core/Fab"
import DownIcon from "@material-ui/icons/KeyboardArrowDown"
import UpIcon from "@material-ui/icons/KeyboardArrowUp"
// eslint-disable-next-line
import HelpIcon from "@material-ui/icons/HelpOutline"
import grey from "@material-ui/core/colors/grey"
import Paper from "@material-ui/core/Paper"


// UTILS
import * as _ from "lodash"

// FLASH
// eslint-disable-next-line
import FlashTopBar from "../Flash/FlashTopBar.js"
import FlashHeader from "../Flash/FlashHeader.js"
// eslint-disable-next-line
import FlashSubHeader from "../Flash/FlashSubHeader.js"
// import FlashBottomBar from "../Flash/FlashBottomBar.js"
import FlashShare from "./../FlashShare.js"
import FlashBottomPad from "../Flash/FlashBottomPad.js"
import FlashSentimentPad from "../Flash/FlashSentimentPad.js"

import {
    deepCopy
} from "./../Utils.js"

import { 
    genUrl
} from "../../bl/A/bl"

// NEXT: do the go to the next one immediately thing here


// LogRocket
//import LogRocket from 'logrocket'




// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<Sentiment>")
const VARIATION = "A"

//LogRocket.init('sbqpcc/flashdev')



const styles = theme => ({
    //
    // GLOBAL STYLES START
    //
    
    separatorDiv: {
        ...theme.css.separatorDiv,
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
            // borderRadius: theme.css.separatorDiv.desktop.borderRadius,
            // boxShadow: theme.css.separatorDiv.desktop.boxShadow,
            // borderTopLeftRadius: 6,
            // borderTopRightRadius: 6,
        },
    },

    checkedCircle: {
        ...theme.css.checkedCircle
    },

    uncheckedCircle: {
        ...theme.css.uncheckedCircle
    },


    //
    // GLOBAL STYLES END
    //


    // SCROLL FAB
    /*
    fab: {
        position: "fixed",
        bottom: theme.spacing(12),
        //        right: theme.spacing(1),
        left: "65%",
        zIndex: 10,
        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            left: "60%",
        },

    },
    
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.custom.scrollDark,
        '&:hover': {
            backgroundColor: theme.palette.custom.scrollLight,
        },
    },
    */
    
    continueButton: {
        margin: 20,
        padding: 8,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },


    contactList: {
        margin: 0,
        marginTop: 0,
        // tab from the left
        padding: "0px",
        // inside the container
        width: "100%",
    },

    contactItem: {
        // gap between cards (individual items)
        margin: 0,
        // cursor: "pointer",
        borderRadius: 0, // default 4
    },


    //
    // new stuff
    //
    mainDiv: {
        // mobile
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    maxWidth: 600,
//            marginBottom: 120,
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    paperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
//        maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 15,
            borderRadius: 6,
        },
        
    },

    optionsPaperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
//        padding: 10,
//        paddingTop: 10,
//        paddingBottom: 10,
//        maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
//            marginTop: 15,
            //            borderRadius: 6,
            borderRadius: 0,
        },
        
    },


    // SCROLL FAB
    fab: {
        position: "fixed",
        //        bottom: theme.spacing(12),
                bottom: theme.spacing(2),

        //        right: theme.spacing(1),
        //        left: "45%", // middle

        left: "83%", // middle

        zIndex: 500,
        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            left: "75%",
        },

    },
    
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.custom.scrollDark,
        '&:hover': {
            backgroundColor: theme.palette.custom.scrollLight,
        },
    }
    
    
})

class Sentiment extends Component {

    constructor(props) {
        super(props)
        log.debug("constructor()")

        // TODO: do all proper initialization here
        this.state = {
            redirectBack: false,
            redirectContinue: false,
            scrollerDirection: "down",
            showButtomPad: false
        }
    }



    handleContinueClick = () => {
        log.debug("handleContinueClick()")
        // get all the checked contacts
        let checkedItems = _.filter(this.state.gl.issues, ["isChecked", true])
        log.debug("handleContinueClick(): checkedItems = ", checkedItems)

        let localGL = this.state.gl
        localStorage.setItem("gl", JSON.stringify(localGL))
        log.debug("handleContinueClick(): saved localGL")

        this.setState({redirectContinue: true})
    }

    handleBackClick = () => {
        log.debug("handleBackClick()")
        this.setState({redirectBack: true})
    }

    handleCloseClick = () => {
        log.debug("handleCloseClick()")
        this.setState({redirectClose: true})
    }
    
    handleCheckboxChange = uuid => event => {
        log.debug(` handleCheckboxChange(): uuid = ${uuid}, event = ${event}`)
        let item = (_.filter(this.state.gl.options, ["uuid", uuid]))[0]
        log.debug("handleCheckboxChange(): option found = ", item)
        if(!item.isChecked) {
            item.isChecked = true
        } else if(item.isChecked === true) {
            item.isChecked = false
        } else if(item.isChecked === false) {
            item.isChecked = false
        }

        log.debug("handleCheckboxChange(): item.isChecked = ", item.isChecked)

        this.setState({gl: this.state.gl})
    }


    handleShareClick = () => {
        log.debug("handleShareClick()")
        this.setState({isShareVisible: true})
    }

    handleShareDone = () => {
        log.debug("handleShareDone()")
        this.setState({isShareVisible: false})
    }

    handleSentimentResult = sentiment => result => {
        log.debug("handleSentimentResult(): sentiment =", sentiment)
        log.debug("handleSentimentResult(): result =", result)
        log.debug("handleSentimentResult(): this.state.gl.currentIssue =", this.state.gl.currentIssue)

        const newCurrentIssue = deepCopy(this.state.gl.currentIssue)
        log.debug("handleSentimentResult(): fresh newCurrentIssue =", newCurrentIssue)

        switch(sentiment) {
        case "positive":
            log.debug("handleSentimentResult(): handling sentiment =", sentiment)
            newCurrentIssue.sentiment = sentiment
            break
        case "negative":
            log.debug("handleSentimentResult(): handling sentiment =", sentiment)
            newCurrentIssue.sentiment = sentiment
            break
        default:
            return
        }

        const newGl = {
                    ...this.state.gl,
                    currentIssue: newCurrentIssue
        }
              

        log.debug("handleSentimentResult(): newGl =", newGl)
        localStorage.setItem("gl", JSON.stringify(newGl))

        this.setState({gl: newGl, redirectClose: true})
        //        this.setState({showBottomPad: true})

        /*

        this.setState({
                gl: {
                    ...this.state.gl,
                    currentIssue: newCurrentIssue
                }
        })

        localStorage.setItem("gl", JSON.stringify(this.state.gl))
        this.setState({showBottomPad: true})
*/
        
        /*
        if(result === "positive") {
            // this.state.gl.currentIssue.sentiment = "positive"
            this.setState({
                gl: {
                    ...this.state.gl,
                    currentIssue: {
                        ...this.state.gl.currentIssue,
                        sentiment: "positive"
                    }
                }
            })
        } else if (result === "negative") {
            // this.state.gl.currentIssue.sentiment = "negative"
            this.setState({
                gl: {
                    ...this.state.gl,
                    currentIssue: {
                        ...this.state.gl.currentIssue,
                        sentiment: "negative"
                    }
                }
            })
        }

        log.debug("handleSentimentResult(): saving localGL with issue sentiment")
        localStorage.setItem("gl", JSON.stringify(this.state.gl))
        
        this.setState({showBottomPad: true})
        // this.scrollToBottom() this does not work, but we have a better solution
        */
    }


    componentWillUnmount  = () => {
        window.removeEventListener("scroll", this.handleScroll)
    }
    
    UNSAFE_componentWillMount = () => {
        log.debug("componentWillMount()")
        let localGL = JSON.parse(localStorage.getItem("gl"))
        log.debug("componentWillMount(): localGL = ", localGL)


        if(!localGL.options) {
            localGL.options = [
                {uuid: "1", txt: "Get confirmation that your representative heard you"},
                {uuid: "2", txt: "Get alerts on changes to your issue"},
                {uuid: "3", txt: "Become a resource for your representative on this issue"},
                {uuid: "4", txt: "Track the impact of your reasons on this issue"},
            ]
        }
        
        this.setState({
            scrollerDirection: "down",
            gl: localGL,
            variation: {
                  current: VARIATION,
                  A: "/preview/a",
                  B: "/preview/b",
              }
        })
    }


    componentDidMount = () => {
        window.addEventListener("scroll", this.handleScroll);
        this.scrollToTop()
    }

    handleScroll = (event) => {
        log.trace("<Issues>: handleScroll(): event = ", event)

        if(!this.state.scrollerDirection) {
            this.setState({scrollerDirection: "down"})
            return
        }

        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        log.trace("handleScroll(): window.pageYOffset =", window.pageYOffset)

        if (windowBottom >= (docHeight - 1)) {
            this.setState({scrollerDirection: "up"})
        } else if(window.pageYOffset === 0) {
            this.setState({scrollerDirection: "down"})
        }
    }

    scrollToBottom = () => {
        log.debug("<Issues>: scrollToBottom(): this.contentDivEl = ", this.contentDivEl)
        log.debug("<Issues>: scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.tailDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }


    scrollToTop = () => {
        log.debug("<Issues>: scrollToBottom(): this.headDivEl = ", this.headDivEl)
        log.debug("<Issues>: scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.headDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }

    render() {
        const { classes } = this.props

        // redirects first
        if (this.state.redirectBack) {
            return <Redirect push to="/summary"/>
        } else if(this.state.redirectClose) {
            return <Redirect push to={genUrl(this)("/summary")}/>
        } else if(!this.state.gl.currentIssue) {
            // check if this is a valid location at the moment
            // we should have a valid this.state.gl.currentIssue
            return <Redirect push to="/contacts"/>
        }

        //
        // CONTACTS
        //
        let contacts = this.state.gl.contacts
        let checkedContacts = _.filter(contacts, ["isChecked", true])
        log.debug("render(): checkedContacts = ", checkedContacts)

        // City
        let cityContacts = _.filter(checkedContacts, ["level", "city"])
        let hasCityContacts = false
        if(cityContacts.length > 0) hasCityContacts = true
        log.debug("render(): hasCountyContacts = ", hasCityContacts)

        // County
        let countyContacts = _.filter(checkedContacts, ["level", "county"])
        let hasCountyContacts = false
        if(countyContacts.length > 0) hasCountyContacts = true
        log.debug("render(): hasCountyContacts = ", hasCountyContacts)

        // State
        let stateContacts = _.filter(checkedContacts, ["level", "state"])
        let hasStateContacts = false
        if(stateContacts.length > 0) hasStateContacts = true
        log.debug("render(): hasStateContacts = ", hasStateContacts)

        // Federal
        let federalContacts = _.filter(checkedContacts, ["level", "federal"])
        let hasFederalContacts = false
        if(federalContacts.length > 0) hasFederalContacts = true
        log.debug("render(): hasFederalContacts = ", hasFederalContacts)


        //
        // Issues
        //
        let currentIssue = this.state.gl.currentIssue
        let statements = this.state.gl.statements
        let currentStatements = _.filter(statements, ["issue.uuid", currentIssue.uuid])
        currentStatements = _.sortBy(_.filter(currentStatements, ["isChecked", true]), ["rank"])

        //
        // Options
        //
        // eslint-disable-next-line
        let optionsItems = this.state.gl.options


        // let headerText1 = "How do you feel about this issue?"
        //        let headerText1 = "In general, how do you regard this issue?"
        let headerText1 = "Your Views on the Issue"
        // let subsection1Text1 = "Your Representatives"
        let separatorText = []
        separatorText.push("Federal")        

        /*
        // ND Special
        if(this.state.gl.user.geo.address.zipPlus4 === "12345-0000") {
            log.debug("render(): I'm an ND case!!")
            subsection1Text1 = "Directed to:"
            separatorText.pop()
            separatorText.push("Officials")
        }
        */
                
	return(
            <React.Fragment>
	      <CssBaseline/>

              <div ref={(el) => { this.headDivEl = el; }} ></div>
              
              <FlashShare isVisible={this.state.isShareVisible} variant="summary" onDone={this.handleShareDone}/>

              <FlashTopBar text="Your Message" variation={this.state.variation}/>
              
              <div className={classes.mainDiv}>
                
                {/*
                <FlashSubHeader text1={
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        width: 350,
                    }}>
                      <div>
                        <HelpIcon style={{fontSize: 30, color: grey[500], paddingTop: 0, marginRight: 5,}}/>
                      </ div>
                      <div style={{marginBottom: 5}}>
                        <Typography className={classes.subheaderText} variant="h6">
                          Sentiment your message
                        </Typography>
                      </div>
                    </div>
                }>
                  <Typography className={classes.subheaderText} variant="subtitle" style={{fontSize: 18, marginLeft: 10, fontWeight: 400 }}>
                    <div style={{display: "inline", fontWeight: 400}}>You can go back and change, or advance to submit</div>
                  </Typography>
                </FlashSubHeader>
                 */}

                <FlashHeader text={headerText1} style={{marginTop: 0, marginBottom: 25}}/>
                {/*
                <FlashSubHeader style={{marginBottom: 100}} text1={
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        width: 400,
                    }}>
                      <div style={{marginBottom: 5}}>
                        <Typography className={classes.subheaderText} variant="h6">
                          Click on the box to select an issue
                        </Typography>
                      </div>
                      <div style={{}}>
                        <HelpIcon style={{fontSize: 30, color: grey[500], paddingTop: 0, marginLeft: 5,}}/>
                      </div>
                    </div>
        }>
                  <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 18, marginLeft: 10 }}>
                    <div style={{display: "inline", fontWeight: 400}}>We'll find the issues they cover</div>
                  </Typography>
                </FlashSubHeader>
                 */}
                
                

                {/*
                <FlashHeader style={{fontSize: 25}} text={subsection1Text1}/>

                { hasCityContacts &&
                  <div>
                    <div className={classes.separatorDiv}>
                      <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 18 }}>
                        City
                      </Typography>
                    </div>
                    
                    <ul className={classes.contactList}>
                      {cityContacts.map((value, index) => (
                          <Paper className={classes.paperRoot} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                                <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>
                                  {value.person.name}
                                </Typography>
                                <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16}}>
                                  {value.position.description}
                                </Typography>
                              </div>
                            </div>
                          </Paper>
                      ))}
                    </ul>
                  </div>
                }


                { hasCountyContacts &&
                  <div>
                    <div className={classes.separatorDiv}>
                      <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 18 }}>
                        County
                      </Typography>
                    </div>
                    
                    <ul className={classes.contactList}>
                      {countyContacts.map((value, index) => (
                          <Paper className={classes.paperRoot} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                                <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>
                                  {value.person.name}
                                </Typography>
                                <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16}}>
                                  {value.position.description}
                                </Typography>
                              </div>
                            </div>
                          </Paper>
                      ))}
                    </ul>
                  </div>
                }

                { hasStateContacts &&
                  <div>
                    <div className={classes.separatorDiv}>
                      <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 18 }}>
                        State
                      </Typography>
                    </div>
                    
                    <ul className={classes.contactList}>
                      {stateContacts.map((value, index) => (
                          <Paper className={classes.paperRoot} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                            <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>
                                  {value.person.name}
                                </Typography>
                                <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16}}>
                                  {value.position.description}
                                </Typography>
                                <div/>
                              </div>
                            </div>
                          </Paper>
                      ))}
                    </ul>
                  </div>
                }


                { hasFederalContacts &&
                  <div>
                    <div className={classes.separatorDiv}>
                      <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                        {separatorText[0]}
                      </Typography>
                    </div>
                    
                    <ul className={classes.contactList}>
                      {federalContacts.map((value, index) => (
                          <Paper className={classes.paperRoot} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                                <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>                                  {value.person.name}
                                </Typography>
                                <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16}}>
                                  {value.position.description}
                                </Typography>
                                <div/>
                              </div>
                            </div>
                          </Paper>
                      ))}
                    </ul>
                  </div>
                }
                 */}

                {/*                <div style={{textAlign: "center", backgroundColor: "#f5f5f5f5"}}> */}
                {/*
                <div style={{textAlign: "center", marginTop: 10, marginBottom: 10}}>                
                  <Typography style={{color: grey[800], fontWeight: 600}} variant="h6" color="inherit">
                    Your Issues
                  </Typography>
                </div>
                 */}

                {/*                <FlashHeader style={{fontSize: 25, marginTop: 25}} text="Your Issue"/> */}

                <div className={classes.separatorDiv}>
                  <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    {currentIssue.txt}
                  </Typography>
                </div>
                
                <ul className={classes.contactList}>
                  {currentStatements.map((value, index) => (
                      <Paper className={classes.paperRoot} key={index}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                          <div>
                            <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 18, fontWeight: 400 }}>
                              {value.txt}
                            </Typography>
                      {/*
                            <Typography variant="h6" style={{marginLeft: 20, fontSize: 17}}>
                              Rating: {value.rate}
                            </Typography>
                       */}

                            <Typography variant="h6" style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>
                              Rank: {value.rank}
                            </Typography>
                          </div>
                      </div>
                      </Paper>
                  ))}
                </ul>

                {/*
                <FlashHeader text="Track and Share"/>


                <div className={classes.separatorDiv}>
                  <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    Connections
                  </Typography>
                </div>
                
                <ul className={classes.contactList}>
                  {optionsItems.map((value, index) => (
                      <Paper className={clsx(classes.optionsPaperRoot)}  key={index}
                             style={{
                                 marginTop: (index === 0) ? 15 : null,
                                 borderTopLeftRadius: (index === 0) ? 6 : 0,
                                 borderTopRightRadius: (index === 0) ? 6 : 0,
                                 borderTop: 0,
                                 borderBottom: 0,
                             }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                          <div>
                            <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 18 }}>
                              {value.txt}
                            </Typography>
                          </div>
                          <Checkbox
                            icon={<UncheckedCircle style={{color: grey[700], fontSize: 35}}/>}
                            checkedIcon={<CheckedCircle style={{color: grey[700], fontSize: 35}}/>}
                            onChange={this.handleCheckboxChange(value.uuid)}
                            checked={value.isChecked}
                          />
                      </div>
                      </Paper>
                  ))}
                  <Paper className={classes.optionsPaperRoot} key={100}
                         style={{borderBottomLeftRadius: 6,
                             borderBottomRightRadius: 6, }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div>
                        <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 18 }}>
                          Share your positions with your friends
                        </Typography>
                      </div>
                      <ShareIcon style={{color: grey[700], fontSize: 35, margin: 10, marginRight: 11}} onClick={this.handleShareClick}/>
                    </div>
                  </Paper>
                </ul>
                 */}

                <FlashHeader text={`In general, how do you feel about ${currentIssue.txt}?`} style={{marginTop: 30, marginBottom: 25}}/>

                
                
              </div>
              
              {/*
              <FlashBottomBar
                backButton={{
                    text: "BACK",
                    link: "/rankings",
                    //                    onClick: this.handleBack
                }}
                nextButton={{
                    text: "NEXT",
                    link: "/summary",

                    // if we go back to submit it's
                    // text: "SUBMIT"
                    // link: "/submit"
                    // and the routines below
                    // we dont' have to do anything on preview
                    //                    onClick: this.handleNext,
                    //                    onError: this.handleError,
                }}/>
               */}


              { this.state.scrollerDirection && this.state.scrollerDirection === "down" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToBottom}>
                  <DownIcon style={{fontSize: 50}}/>
                </Fab>
              }

              { this.state.scrollerDirection && this.state.scrollerDirection === "up" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToTop}>
                  <UpIcon style={{fontSize: 50}}/>
                </Fab>
              }
              
              {/*
                 this can show up later

               */}

              

              { !this.state.showBottomPad &&
              <FlashSentimentPad
                leftButton={{
                    text: "NEGATIVE",
                    onClick: this.handleSentimentResult("negative")
                }}
                rightButton={{
                    text: "POSITIVE",
                    onClick: this.handleSentimentResult("positive")
                    //onClick: this.handleNext,
                    // onError: this.handleNextError,
                }}
              />
              }
              

              { this.state.showBottomPad &&
                <FlashBottomPad
                  backButton={{
                      text: "BACK",
                      link: genUrl(this)("/rankings"),                      
                      //link: "/rankings",
                      //                    onClick: this.handleBack
                  }}
                  nextButton={{
                      text: "NEXT",
                      link: genUrl(this)("/preview"),                      
//                      link: "/preview",
                      //                    onClick: this.handleNext,
                      //                    onError: this.handleNextError,
                  }}
                />
              }

              <div ref={(el) => { this.tailDivEl = el; }} ></div>
            </React.Fragment>
	)
    }
}

Sentiment.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {name: "Sentiment"})(Sentiment)

